module.exports = __webpack_public_path__ + "fcda2fa9041c7ea0525833650293ae18.png";